export default function ServiceWorkerRegister() {
    if (!('serviceWorker' in navigator)) return;

    const serviceWorkerPath = `${process.env.PUBLIC_URL}/service-worker.js`;
    let reloadedForUpdate = false;

    // Because the SW calls skipWaiting(), the updated worker activates and
    // takes control automatically. When that happens, reload once so the page
    // runs the newly deployed build instead of the one already in memory.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloadedForUpdate) return;
        // Don't interrupt an in-flight offline photo upload; a later navigation
        // (or the next controllerchange) will pick up the new build.
        if (localStorage.getItem('isUploading') === 'true') return;
        reloadedForUpdate = true;
        window.location.reload();
    });

    window.addEventListener('load', function () {
        navigator.serviceWorker.register(serviceWorkerPath).then((registration) => {
            // Long-lived tabs won't re-check on their own often, so poll for an
            // updated service-worker.js so a fresh deploy is noticed quickly.
            setInterval(() => {
                try { registration.update(); } catch (e) { /* ignore */ }
            }, 5 * 60 * 1000);
        }).catch(() => {
            // Registration failed - app still works without the SW.
        });
    });
}
